import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import {Link as RouterLink} from "react-router";

import {createSearchUrl} from "./createSearchUrl";

export default function SearchTip() {
    return (
        <Typography component="p" sx={{mt: 2}}>
            Try searching for something like{" "}
            <Link component={RouterLink} to={createSearchUrl("ESP32")} color="primary">
                ESP32
            </Link>
            ,{" "}
            <Link component={RouterLink} to={createSearchUrl("SEEED", "orgs")} color="primary">
                SEEED
            </Link>
            ,{" "}
            <Link component={RouterLink} to={createSearchUrl("Jharwin", "users")} color="primary">
                Jharwin
            </Link>{" "}
            or{" "}
            <Link component={RouterLink} to={createSearchUrl("Capacitor", "components")} color="primary">
                Capacitor
            </Link>
            .
        </Typography>
    );
}
